<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oPfngW/tc-custom/9780226527239.jpg?1733103890134" alt="This image is the cover for the book Conflagration of Community"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Conflagration of Community
      </h1>
      <p class="bookDescription body article font2">
        <p>“After Auschwitz to write even a single poem is barbaric.” <i>The Conflagration of Community</i> challenges Theodor Adorno’s famous statement about aesthetic production after the Holocaust, arguing for the possibility of literature to bear witness to extreme collective and personal experiences. J. Hillis Miller masterfully considers how novels about the Holocaust relate to fictions written before and after it, and uses theories of community from Jean-Luc Nancy and Derrida to explore the dissolution of community bonds in its wake.</p>Miller juxtaposes readings of books about the Holocaust—Keneally’s <i>Schindler’s List</i>, McEwan’s <i>Black Dogs</i>, Spiegelman’s <i>Maus</i>, and Kertész’s <i>Fatelessness</i>—with Kafka’s novels and Morrison’s <i>Beloved</i>, asking what it means to think of texts as acts of testimony. Throughout, Miller questions the resonance between the difficulty of imagining, understanding, or remembering Auschwitz—a difficulty so often a theme in records of the Holocaust—and the exasperating resistance to clear, conclusive interpretation of these novels. <i>The Conflagration of Community</i> is an eloquent study of literature’s value to fathoming the unfathomable.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Hillis Miller
      </h2>
      
      <p class="authorDescription body article"><P><B>J. Hillis Miller</B> is Distinguished Research Professor of Comparative Literature and English at the University of California, Irvine. He is the author of many books and articles on literature and literary theory, most recently of&#160;<I>For Derrida</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2938ab4a